import {
  IntegrationStatus,
  InternalIntegrationSetting,
} from 'models/InternalIntegrationSetting';
import Switch from 'components/switch/Switch';
import Button from 'components/button/Button';
import { useTranslation } from 'react-i18next';
import useDisableAgencyIntegrationModal from 'pages/channels/components/modals/disableAgencyChannel/useDisableAgencyChannelModal';
import { QueryKey } from '@tanstack/react-query';
import { Link } from 'react-router-dom';

const InboundOAuthSwitch = ({
  integration,
  queryKey,
}: {
  integration: InternalIntegrationSetting;
  queryKey: QueryKey;
}) => {
  const { t } = useTranslation();
  const { openDisableAgencyIntegrationModal } =
    useDisableAgencyIntegrationModal();

  const {
    integration: {
      connectionConfig: { connectLink },
    },
    agencySettings: { status },
  } = integration;

  const isActive = status === IntegrationStatus.ACTIVE;

  const handleConfirmDisable = () => {
    if (isActive) {
      openDisableAgencyIntegrationModal({
        integration,
        queryKey,
      });
    }
  };

  return !isActive ? (
    <Link to={connectLink ?? ''} target="_blank" rel="noreferrer">
      <Button
        bsStyle="primary"
        data-testid="connect-via-partner-button"
        className="connect-via-partner-button"
        disabled={!connectLink}
      >
        {t('pageChannels.table.connectViaPartner')}
      </Button>
    </Link>
  ) : (
    <Switch
      data-testid="channel-status-switch"
      className="small"
      checked={isActive}
      onClick={(e) => {
        e.stopPropagation();
        handleConfirmDisable();
      }}
    />
  );
};

export default InboundOAuthSwitch;
